import { render, staticRenderFns } from "./UsuariosListado.vue?vue&type=template&id=027ba8bf"
import script from "./UsuariosListado.vue?vue&type=script&lang=js"
export * from "./UsuariosListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports